import axios from 'axios'

const client = axios.create({ baseURL: 'https://phrasalverbsrepo.onrender.com/api' })

export default client